import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=311244f1&scoped=true&"
import script from "./UserComponent.vue?vue&type=script&lang=js&"
export * from "./UserComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserComponent.vue?vue&type=style&index=0&id=311244f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311244f1",
  null
  
)

export default component.exports